import React, { useState } from 'react';

function Contact() {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    e.target.reset();
  };

  return (
    <section id="contact" className="section" style={{ overflow: 'hidden' }}>
      <div className="accent-orb" style={{ width: 600, height: 600, top: -200, left: '50%', transform: 'translateX(-50%)', animationDelay: '1s' }}></div>

      <div className="section-inner">
        <div className="section-header-center rv">
          <span className="label-tag" style={{ marginBottom: '1.5rem', display: 'inline-block' }}>Contact</span>
          <h2 className="section-title" style={{ marginBottom: '1.25rem' }}>
            Let's build something<br />remarkable together
          </h2>
          <p className="section-desc">
            Tell us about your project and we'll get back within 24 hours with a tailored proposal.
          </p>
        </div>

        <div className="contact-grid">
          {/* Form */}
          <div className="rv rv-d1">
            <form onSubmit={handleSubmit}>
              <div className="form-row" style={{ marginBottom: '1.25rem' }}>
                <div>
                  <label className="form-label">Full Name</label>
                  <input type="text" placeholder="Jane Smith" className="form-field" required />
                </div>
                <div>
                  <label className="form-label">Email</label>
                  <input type="email" placeholder="jane@company.com" className="form-field" required />
                </div>
              </div>
              <div className="form-group">
                <label className="form-label">Project Type</label>
                <select className="form-field">
                  <option value="">Select a service...</option>
                  <option>Web Development</option>
                  <option>App Development</option>
                  <option>UI/UX Design</option>
                  <option>Cloud Architecture</option>
                  <option>AI Integration</option>
                  <option>Full Product Build</option>
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">Tell Us More</label>
                <textarea
                  rows="5"
                  placeholder="Brief overview of your project, goals, timeline, and budget range..."
                  className="form-field"
                  required
                ></textarea>
              </div>
              <button type="submit" className="btn-ember" style={{ padding: '0.875rem 2rem', width: '100%', justifyContent: 'center' }}>
                Send Inquiry <i className="fa-solid fa-paper-plane" style={{ fontSize: '0.75rem' }}></i>
              </button>
              {submitted && (
                <div className="form-success">
                  <i className="fa-solid fa-check-circle" style={{ marginRight: '0.5rem' }}></i>
                  Thank you! We'll be in touch within 24 hours.
                </div>
              )}
            </form>
          </div>

          {/* Info */}
          <div className="rv rv-d3">
            <div>
              <h3 style={{ fontSize: '1.125rem', fontWeight: 700, color: '#f2f2f2', marginBottom: '0.5rem' }}>
                Get in touch directly
              </h3>
              <p style={{ fontSize: '0.875rem', color: '#666', lineHeight: 1.7, marginBottom: '2rem' }}>
                Prefer a direct conversation? Reach out through any of these channels.
              </p>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem', marginBottom: '2rem' }}>
                <a href="tel:+9779840337397" className="contact-info-block">
                  <div className="contact-icon"><i className="fa-solid fa-phone"></i></div>
                  <div>
                    <p className="contact-info-label">Phone</p>
                    <p className="contact-info-value">9840337397</p>
                  </div>
                </a>

                <a href="tel:+9779826162347" className="contact-info-block">
                  <div className="contact-icon"><i className="fa-solid fa-phone"></i></div>
                  <div>
                    <p className="contact-info-label">Phone (Alt)</p>
                    <p className="contact-info-value">9826162347</p>
                  </div>
                </a>

                <a href="mailto:safalneupane@squareproduction.com" className="contact-info-block">
                  <div className="contact-icon"><i className="fa-solid fa-envelope"></i></div>
                  <div>
                    <p className="contact-info-label">Email</p>
                    <p className="contact-info-value">safalneupane@squareproduction.com</p>
                  </div>
                </a>

                <div className="contact-info-block">
                  <div className="contact-icon"><i className="fa-solid fa-location-dot"></i></div>
                  <div>
                    <p className="contact-info-label">Office</p>
                    <p className="contact-info-value">Birauta-17<br />Pokhara, Nepal</p>
                  </div>
                </div>

                <div className="contact-info-block">
                  <div className="contact-icon"><i className="fa-solid fa-clock"></i></div>
                  <div>
                    <p className="contact-info-label">Hours</p>
                    <p className="contact-info-value">Sun – Fri: 10 AM – 6 PM NPT</p>
                  </div>
                </div>
              </div>

              <div style={{ paddingTop: '1.5rem', borderTop: '1px solid rgba(255,255,255,0.04)' }}>
                <p style={{ fontSize: '0.75rem', color: '#666', fontFamily: "'Fira Code', monospace", textTransform: 'uppercase', letterSpacing: '0.15em', marginBottom: '1rem' }}>Follow</p>
                <div className="social-links">
                  <button type="button" className="social-link" aria-label="LinkedIn"><i className="fa-brands fa-linkedin-in"></i></button>
                  <button type="button" className="social-link" aria-label="X / Twitter"><i className="fa-brands fa-x-twitter"></i></button>
                  <button type="button" className="social-link" aria-label="GitHub"><i className="fa-brands fa-github"></i></button>
                  <button type="button" className="social-link" aria-label="Dribbble"><i className="fa-brands fa-dribbble"></i></button>
                  <button type="button" className="social-link" aria-label="Instagram"><i className="fa-brands fa-instagram"></i></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
